export { DefaultSpacing } from '@fluentui/theme/lib/spacing/DefaultSpacing';
